import { marked } from "marked";
import { type MouseEvent, useMemo } from "react";

function handleClick(evnt: MouseEvent<HTMLDivElement>) {
  const target = evnt.target;
  if (!(target instanceof HTMLAnchorElement)) {
    return;
  }

  const href = target.getAttribute("href");
  if (!href) {
    return;
  }

  if (/^\//.test(href)) {
    evnt.preventDefault();
    window.location.assign(href);
  } else {
    // Open external links in a new tab.
    // Note: setting target here won't affect the current click —
    // we need to handle the navigation ourselves.
    evnt.preventDefault();
    window.open(href, "_blank", "noopener,noreferrer");
  }
}

interface MarkdownProps {
  markdown?: string | null;
}

export function Markdown({ markdown }: MarkdownProps) {
  const html = useMemo(() => {
    if (markdown) {
      return marked.parse(markdown, { async: false });
    }
    return null;
  }, [markdown]);

  if (!html) {
    return null;
  }

  return <div dangerouslySetInnerHTML={{ __html: html }} className="markdown" onClick={handleClick}/>;
}
